import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7271/api';

// Types
export enum CalendarEventType {
  Appointment = 1,
  Reminder = 2,
  Committee = 3
}

export interface CalendarEvent {
  id: number;
  title: string;
  description?: string;
  eventType: CalendarEventType;
  eventTypeName: string;
  startDateTime: string;
  endDateTime?: string;

  // For Reminders
  reminderType?: number;
  reminderTypeName?: string;
  reminderPriority?: number;
  reminderPriorityName?: string;
  reminderStatus?: number;

  // For Appointments
  appointmentType?: number;
  appointmentTypeName?: string;
  appointmentStatus?: number;
  appointmentStatusName?: string;
  doctorName?: string;
  meetingType?: number;
  meetingTypeName?: string;

  // Linked entity information
  entityType?: number;
  entityId?: number;
  clientName?: string;
  clientId?: number;

  // Visual properties for calendar display
  color: string;
  isOverdue: boolean;
  isHighPriority: boolean;

  // Metadata
  assignedUserId: number;
  assignedUserName?: string;
  createdAt: string;
}

// API calls
export const calendarApi = {
  // Get calendar events within a date range
  getCalendarEvents: async (startDate: string, endDate: string): Promise<CalendarEvent[]> => {
    const response = await axios.get(`${API_BASE_URL}/calendar/events`, {
      params: { startDate, endDate }
    });
    return response.data;
  }
};

export default calendarApi;
